import { Component, OnInit } from '@angular/core';
import { Message } from 'primeng/api';
import { MessageService } from './message.service';

@Component({
	selector: 'pm-message',
	template: `
    <p-growl id="simple" [(value)]="msgs"></p-growl>
    <p-growl id="sticky" [(value)]="msgsSticky" sticky="true"></p-growl>
  `,
	styleUrls: [],
})
export class MessageComponent implements OnInit {
	msgs: Message[] = [];
	msgsSticky: Message[] = [];
	constructor(private messageService: MessageService) { }

	ngOnInit() {
		this.messageService.currentSticky.subscribe(msgs => {
			if (msgs != null && msgs.length > 0) {
				this.msgsSticky.push(msgs[0]);
			} else {
				this.msgsSticky = [];
			}
		});
		this.messageService.currentShort.subscribe(msgs => {
			if (msgs != null && msgs.length > 0) {
				this.msgs = msgs; // replace instead of append
			}
		});
	}
}
